<template>
  <div
    id="menu-bottom"
    class="menu-bottom"
    :class="{ show: showMenu }"
    @click.prevent="showMenu = !showMenu"
  >
    <a href="javascript:void(0)">
      <img src="/images/menu.png" class="img-fluid img-flip-on-rtl" alt="" />
      <div class="detail">
        <img src="/images/svg/cart-menu.svg" class="img-fluid" alt="" />
        <span>{{ _T('menu') }}</span>
      </div>
    </a>
    <div class="menu-open">
      <span class="close_menu">X</span>
      <ul v-if="!all_store_categories_being_loaded">
        <scrollactive
          class="my-nav"
          :offset="145"
          id="scroll-move"
          highlightFirstItem
        >
          <li
            class="filter-link"
            v-for="(category, index) in all_store_categories"
            :key="category._id"
            :index="index"
            :data-index="index"
            :class="{ active: activeCategory === seoName(category.name) }"
          >
            <router-link
              name="routerlink"
              class="filter-link scrollactive-item"
              v-if="category_products(category._id).length"
              :to="{
                name: brandStoreRoute('store_page_category'),
                params: {
                  category_name: seoName(category.name),
                },
              }"
            >
              <h4>{{ _T_DB(category, 'name') }}</h4>
            </router-link>
          </li>
        </scrollactive>
      </ul>
    </div>
    <div class="overlay" @click="showMenu = false"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { seo_name } from '@/utils/main_utils'
export default {
  name: 'CategoryMenuButton',
  components: {},
  data() {
    return {
      showMenu: false,
    }
  },
  watch: {
    showMenu(newVal) {
      if (newVal) {
        document.body.style.setProperty('overflow-y', 'hidden')
      } else {
        document.body.style.removeProperty('overflow-y')
      }
    },
  },
  methods: {
    seoName(name) {
      return seo_name(name)
    },
  },
  computed: {
    ...mapGetters([
      'all_store_categories',
      'brandStoreParams',
      'brandStoreRoute',
      '_T',
      '_T_DB',
      'all_store_categories_being_loaded',
      'category_products',
    ]),
    activeCategory() {
      if (this.$route.params.category_name) {
        return this.$route.params.category_name
      }
      if (this.all_store_categories && this.all_store_categories.length) {
        return this.seoName(this.all_store_categories[0].name)
      }
      return null
    },
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .img-flip-on-rtl {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
  .menu-bottom {
    right: $px20;
    left: unset !important;
    .menu-open {
      right: 0;
      left: unset !important;
      ul {
        li {
          a {
            h4 {
              text-align: right !important;
            }
          }
        }
      }
    }
  }
}
span.close_menu {
  /* text-align: right; */
  /* display: block; */
  position: absolute;
  top: -11px;
  background: #fff;
  padding: 5px 11px;
  right: -8px;
  border-radius: 100%;
  color: #000;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.85);
  cursor: pointer;
}
.menu-bottom {
  display: block;
  position: fixed;
  left: 0.75rem;
  bottom: 4.125rem;
  z-index: 3;
  .detail {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    span {
      font-weight: 600;
      font-size: $px12;
      line-height: $px22;
      letter-spacing: 0.5px;
      color: $white;
      text-transform: uppercase;
    }
  }
  .menu-open {
    position: absolute;
    left: 0;
    bottom: 0;
    width: $px250;
    border-radius: $px4;
    background-color: $white;
    z-index: 1;
    display: none;
    ul {
      max-height: $px352;
      overflow: auto;
      @extend %default-scroll;
      li {
        display: block;
        font-weight: 600;
        font-size: $px14;
        line-height: $px22;
        align-items: center;
        letter-spacing: 0.5px;
        color: $font-color;
        text-transform: capitalize;
        &.active {
          a {
            color: $color-primary;
            transition: all 0.5s ease;
          }
        }
        a {
          color: $font-color;
          padding: $px14 $px15;
          display: block;
          transition: all 0.5s ease;
        }
        span {
          float: right;
        }
        + li {
          a {
            border-top: $px1 solid $light-border;
          }
        }
      }
    }
  }
  .overlay {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(var(--color-font-color-source), 0.8);
    z-index: -1;
    display: none;
  }
  &.show {
    .menu-open,
    .overlay {
      display: block;
    }
  }
}
@media (max-width: 575px) {
  .menu-bottom {
    display: block;
    .menu-open {
      min-width: 60vw;
      ul {
        max-height: $px400;
        nav {
          li {
            a {
              h4 {
                font-size: 14px;
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }
}
</style>
